export const ORGANISATION_COST_PER_USER_PER_MONTH = 250;
